<template>
  <div v-if="promoProps" class="content">
    <div class="data-horario">
      <i class="far fa-calendar-alt"></i>
      <span>
        {{ new Date(dataOk.toISOString()) | moment("ddd, DD/MM") }}
        <i class="far fa-clock icone-relogio"></i> {{ promoProps.Horario }} |
        {{ promoProps.Turno }}
      </span>
    </div>
    <div v-if="promoProps.ProdutoUrlImagens" class="imagem">
      <img :src="promoProps.ProdutoUrlImagens" />
    </div>
    <div class="dados">
      <div class="expira">
        <div>
          <i class="far fa-hourglass icone-ampulheta"></i>
        </div>
        <countdown
          @end="finalCountdown(promoProps.ProdutoId)"
          :time="dataContador(promoProps.DataFim)"
        >
          <template slot-scope="props">
            <div class="expira-hora" v-if="props.days == 0">
              expira em {{ props.days > 0 ? props.days + "d" : "" }}
              {{ props.hours > 0 ? props.hours + "h" : "" }}
              {{ props.minutes }}m {{ props.seconds }}s
            </div>
            <div class="expira-hora" v-else>
              expira em
              {{
                new Date(
                  corrigeTimestamp(promoProps.DataFim).toDate()
                ).toISOString() | moment("DD/MM")
              }}
              às {{ promoProps.HorarioFim.replace(":", "h") }}
            </div>
          </template>
        </countdown>
      </div>

      <h2>{{ promoProps.ProdutoTitulo.toUpperCase() }}</h2>
      <p class="subtitulo" v-if="promoProps.ProdutoSubTitulo">
        {{ promoProps.ProdutoSubTitulo }}
      </p>
      <div class="data">
        <span v-if="promoProps.SemData == false">
          <i class="far fa-calendar-alt icone-calendario"></i>
          {{ new Date(dataOk.toISOString()) | moment("ddd, DD/MM") }}
          <span v-if="$vssWidth < 400" class="espaco"></span>
        </span>
        <i class="far fa-clock icone-relogio"></i>
        {{ promoProps.Horario }}
        <span> | {{ promoProps.Turno }}</span>
      </div>
      <p class="preco">
        De
        <span class="preco-cardapio">{{
          promoProps.ProdutoPrecoCardapio | numeroPreco
        }}</span>
        por {{ promoProps.PrecoPromocional | numeroPreco }}
      </p>
      <div class="icones2">
        <div v-if="promoProps.Restaurante" class="icones2-div">
          <i class="fas fa-utensils icone_svg2"></i>
          <span>Consumo somente no restaurante</span>
        </div>
        <div v-if="promoProps.DriveThru" class="icones2-div">
          <i class="fas fa-car icone_svg2"></i>
          <span>Disponível para Drive Thru</span>
        </div>
        <div v-if="promoProps.TakeAway" class="icones2-div">
          <i class="fas fa-gift icone_svg2"></i>
          <span>Disponível para retirada / viagem</span>
        </div>
        <div v-if="promoProps.Delivery" class="icones2-div">
          <i class="fas fa-motorcycle icone_svg2"></i>
          <span>Disponível para Delivery</span>
        </div>
      </div>
      <div class="botao">
        <button
          v-bind:style="{
            color: unidadeSelecionada == unidade ? '#FFFFFF' : '#F85E28',
            backgroundColor:
              unidadeSelecionada == unidade ? '#F85E28' : '#FFFFFF',
          }"
          v-for="(qtd, unidade) in unidadesOrdenadas(qtdPromocao)"
          :key="unidade"
          @click="qtd > 0 ? habilitarUnidade(unidade) : estoqueZero(unidade)"
        >
          {{ unidade }} ({{ qtd > 0 ? qtd : 0 }})
        </button>
      </div>
      <div v-if="unidadeSelecionada" class="contador">
        <span v-if="contador > 1" class="adicao-subtracao" @click="contador--"
          >-</span
        >
        <span v-else class="adicao-subtracao">-</span>
        {{ contador }}
        <span
          class="adicao-subtracao"
          @click="adicionaUnidade(unidadeSelecionada)"
          >+</span
        >
      </div>
      <div class="finalizar">
        <button
          class="adicionar"
          @click="adicionarCarrinho(promoProps, $event)"
        >
          ADICIONAR AO CARRINHO
        </button>
      </div>
    </div>
    <div v-html="promoProps.ProdutoDescricao" class="descricao"></div>
    <div v-if="promoProps.PessoasServidas" class="descricao">
      {{ promoProps.PessoasServidas }}.
    </div>
  </div>
</template>

<script>
import { db, Timestamp } from "@/firebase.js";
import { mapActions } from "vuex";
import VueScreenSize from "vue-screen-size";
import _ from "lodash";
import axios from "axios";

export default {
  name: "Home",
  props: ["id"],
  components: {
    db,
  },
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data: function () {
    return {
      promoProps: JSON.parse(localStorage.getItem("promoProps")),
      dataOk: "",
      contador: 0,
      qtdPromocao: {},
      qtdMaxCliente: "",
      unidadeSelecionada: "",
      qtdComprada: {},
    };
  },
  created() {
    this.criandoData(
      JSON.parse(localStorage.getItem("promoProps")).DataOk["seconds"]
    );
    this.checarComprasUsuario();
    this.getQuantidade();
  },
  methods: {
    ...mapActions("carrinho", [
      "adicionarProduto",
      "atualizarProduto",
      "removerProduto",
      "idCarrinho",
      "contadorProdutos",
    ]),
    ...mapActions("menu", ["toggleMenu"]),
    ...mapActions("finalizarCompra", ["removerConfiguracoes"]),
    async checarComprasUsuario() {
      await db
        .collection("Clientes")
        .doc(this.$store.state.usuario.usuario.Email)
        .collection("Compras")
        .where("IdPromocao", "==", this.promoProps.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              if (this.qtdComprada[doc.data().Unidade] == null) {
                this.qtdComprada[doc.data().Unidade] =
                  0 + doc.data().Quantidade;
              } else {
                this.qtdComprada[doc.data().Unidade] =
                  this.qtdComprada[doc.data().Unidade] + doc.data().Quantidade;
              }
            }
          });
        });
    },
    corrigeTimestamp(data) {
      var dataCorrigida = new Timestamp(data.seconds, data.nanoseconds);
      return dataCorrigida;
    },
    dataContador(promocaoDataFim) {
      var dataPromocao = new Timestamp(
        promocaoDataFim.seconds,
        promocaoDataFim.nanoseconds
      );
      return Math.trunc(dataPromocao.toDate() - Date.now());
    },
    finalCountdown(produtoId) {
      this.$router.push({ name: "HomePage" });
    },
    unidadesOrdenadas(unidades) {
      var ordenados = {};
      _(unidades)
        .keys()
        .sort()
        .each((key) => {
          ordenados[key] = unidades[key];
        });
      return ordenados;
    },
    handleOpenMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleMenu(!this.$store.state.menu.aberto);
    },
    controlaEstoque(documentoId) {
      db.collection("Promocoes")
        .doc(documentoId)
        .get()
        .then((doc2) => {
          var mapa = doc2.data().QtdUnidadesReserva;
          mapa[this.unidadeSelecionada] =
            parseInt(doc2.data().QtdUnidadesReserva[this.unidadeSelecionada]) +
            this.contador;
          db.collection("Promocoes").doc(documentoId).update({
            QtdUnidadesReserva: mapa,
          });
        });
    },
    controlaContador(itensCarrinho) {
      var quantidadeCarrinho = 0;
      // eslint-disable-next-line no-unused-vars
      for (var i in itensCarrinho) {
        quantidadeCarrinho = quantidadeCarrinho + 1;
      }
      this.contadorProdutos(quantidadeCarrinho);
    },
    async adicionarCarrinho(documento, event) {
      let loader = this.$loading.show({
        container: null,
        fullPage: true,
        color: "#F85E28",
        loader: "spinner",
        width: 100,
        height: 100,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
      });
      if (
        this.$store.state.finalizarCompra.qrCodePicPay != null ||
        this.$store.state.finalizarCompra.urlPicPay
      ) {
        axios({
          method: "post",
          url: "https://us-central1-loja-ilha-teste.cloudfunctions.net/cancelamentoPicPay",
          data: {
            referenceId: this.$store.state.finalizarCompra.idPedido,
          },
        })
          .then(() => {})
          .catch(() => {});
      }
      this.removerConfiguracoes();
      if (this.contador > 0) {
        if (this.$store.state.carrinho.idCarrinho != null) {
          await db
            .collection("Carrinho")
            .doc(this.$store.state.carrinho.idCarrinho)
            .get()
            .then((doc1) => {
              if (doc1.exists) {
                var documentoFirebase = doc1.data();
                var produto =
                  doc1.data().ItensCarrinho[
                    documento.id + " " + this.unidadeSelecionada
                  ];
                if (produto != null) {
                  var qtdComprada1 =
                    this.qtdComprada[this.unidadeSelecionada] == null
                      ? 0
                      : this.qtdComprada[this.unidadeSelecionada];
                  if (
                    this.contador + produto.Quantidade + qtdComprada1 >=
                    this.qtdMaxCliente
                  ) {
                    this.$fire({
                      text: "Você atingiu a quantidade liberada por cliente para esta promoção",
                    }).then((r) => {
                      setTimeout(() => this.toggleMenu(true), 500);
                    });
                    loader.hide();
                  } else {
                    if (produto.Unidade === this.unidadeSelecionada) {
                      documentoFirebase.ItensCarrinho[
                        documento.id + " " + this.unidadeSelecionada
                      ].Quantidade =
                        documentoFirebase.ItensCarrinho[
                          documento.id + " " + this.unidadeSelecionada
                        ].Quantidade + this.contador;
                      db.collection("Carrinho")
                        .doc(this.$store.state.carrinho.idCarrinho)
                        .update(documentoFirebase);
                      this.controlaEstoque(documento.id);
                      this.controlaContador(documentoFirebase.ItensCarrinho);
                      this.handleOpenMenu(event);
                      loader.hide();
                    } else {
                      const produtoNovaUnidade = {
                        HoraAdicionado: Timestamp.now(),
                        id: this.id + " " + this.unidadeSelecionada,
                        ProdutoTitulo: documento.ProdutoTitulo,
                        Horario: documento.Horario,
                        Quantidade: this.contador,
                        QtdComprada: qtdComprada1,
                        ValorUnitario: documento.PrecoPromocional,
                        Imagem: documento.ProdutoUrlImagens,
                        Unidade: this.unidadeSelecionada,
                        DataOk: new Timestamp(
                          documento.DataOk.seconds,
                          documento.DataOk.nanoseconds
                        ),
                        QtdUnidades:
                          documento.QtdUnidades[this.unidadeSelecionada],
                        QtdUnidadesReserva:
                          documento.QtdUnidadesReserva[this.unidadeSelecionada],
                        QtdMaxCliente: documento.QtdMaxCliente,
                        SemData: documento.SemData,
                      };
                      documentoFirebase.ItensCarrinho[
                        documento.id + " " + this.unidadeSelecionada
                      ] = produtoNovaUnidade;
                      db.collection("Carrinho")
                        .doc(this.$store.state.carrinho.idCarrinho)
                        .update(documentoFirebase);
                      this.controlaEstoque(
                        documento.id,
                        documentoFirebase.ItensCarrinho
                      );
                      this.controlaContador(documentoFirebase.ItensCarrinho);
                      this.handleOpenMenu(event);
                      loader.hide();
                    }
                  }
                } else {
                  var qtdComprada2 =
                    this.qtdComprada[this.unidadeSelecionada] == null
                      ? 0
                      : this.qtdComprada[this.unidadeSelecionada];
                  if (this.contador + qtdComprada2 <= this.qtdMaxCliente) {
                    const produtoNovo = {
                      HoraAdicionado: Timestamp.now(),
                      id: this.id + " " + this.unidadeSelecionada,
                      ProdutoTitulo: documento.ProdutoTitulo,
                      Horario: documento.Horario,
                      Quantidade: this.contador,
                      QtdComprada: qtdComprada2,
                      ValorUnitario: documento.PrecoPromocional,
                      Imagem: documento.ProdutoUrlImagens,
                      Unidade: this.unidadeSelecionada,
                      DataOk: new Timestamp(
                        documento.DataOk.seconds,
                        documento.DataOk.nanoseconds
                      ),
                      QtdUnidades:
                        documento.QtdUnidades[this.unidadeSelecionada],
                      QtdUnidadesReserva:
                        documento.QtdUnidadesReserva[this.unidadeSelecionada],
                      QtdMaxCliente: documento.QtdMaxCliente,
                      SemData: documento.SemData,
                    };
                    documentoFirebase.ItensCarrinho[
                      documento.id + " " + this.unidadeSelecionada
                    ] = produtoNovo;
                    db.collection("Carrinho")
                      .doc(this.$store.state.carrinho.idCarrinho)
                      .update(documentoFirebase);
                    this.controlaEstoque(documento.id);
                    this.controlaContador(documentoFirebase.ItensCarrinho);
                    this.handleOpenMenu(event);
                    loader.hide();
                  } else {
                    this.$fire({
                      text: "Você atingiu a quantidade liberada por cliente para esta promoção",
                    });
                    loader.hide();
                  }
                }
              } else {
                var qtdComprada3 =
                  this.qtdComprada[this.unidadeSelecionada] == null
                    ? 0
                    : this.qtdComprada[this.unidadeSelecionada];
                if (this.contador + qtdComprada3 <= this.qtdMaxCliente) {
                  const produtoNovo = {
                    HoraAdicionado: Timestamp.now(),
                    id: this.id + " " + this.unidadeSelecionada,
                    ProdutoTitulo: documento.ProdutoTitulo,
                    Horario: documento.Horario,
                    Quantidade: this.contador,
                    QtdComprada: qtdComprada3,
                    ValorUnitario: documento.PrecoPromocional,
                    Imagem: documento.ProdutoUrlImagens,
                    Unidade: this.unidadeSelecionada,
                    DataOk: new Timestamp(
                      documento.DataOk.seconds,
                      documento.DataOk.nanoseconds
                    ),
                    QtdUnidades: documento.QtdUnidades[this.unidadeSelecionada],
                    QtdUnidadesReserva:
                      documento.QtdUnidadesReserva[this.unidadeSelecionada],
                    QtdMaxCliente: documento.QtdMaxCliente,
                    SemData: documento.SemData,
                  };
                  var d = new Date();
                  d.setMinutes(d.getMinutes() + 8);
                  var timeStamp = Timestamp.fromDate(d);
                  this.controlaEstoque(documento.id);
                  this.controlaContador(documentoFirebase.ItensCarrinho);
                  db.collection("Carrinho")
                    .add({
                      DataAdicionado: Timestamp.now(),
                      DataExpiracao: timeStamp,
                      ItensCarrinho: {
                        [documento.id + " " + this.unidadeSelecionada]:
                          produtoNovo,
                      },
                    })
                    .then((docRef) => {
                      this.idCarrinho(docRef.id);
                      this.handleOpenMenu(event);
                      loader.hide();
                    });
                } else {
                  this.$fire({
                    text: "Você atingiu a quantidade liberada por cliente para esta promoção",
                  });
                  loader.hide();
                }
              }
            });
        } else {
          var qtdComprada4 =
            this.qtdComprada[this.unidadeSelecionada] == null
              ? 0
              : this.qtdComprada[this.unidadeSelecionada];
          if (this.contador + qtdComprada4 <= this.qtdMaxCliente) {
            var d = new Date();
            d.setMinutes(d.getMinutes() + 8);
            var timeStamp = Timestamp.fromDate(d);
            const produtoNovo = {
              HoraAdicionado: Timestamp.now(),
              id: this.id + " " + this.unidadeSelecionada,
              ProdutoTitulo: documento.ProdutoTitulo,
              Horario: documento.Horario,
              Quantidade: this.contador,
              QtdComprada: qtdComprada4,
              ValorUnitario: documento.PrecoPromocional,
              Imagem: documento.ProdutoUrlImagens,
              Unidade: this.unidadeSelecionada,
              DataOk: new Timestamp(
                documento.DataOk.seconds,
                documento.DataOk.nanoseconds
              ),
              QtdUnidades: documento.QtdUnidades[this.unidadeSelecionada],
              QtdUnidadesReserva:
                documento.QtdUnidadesReserva[this.unidadeSelecionada],
              QtdMaxCliente: documento.QtdMaxCliente,
              SemData: documento.SemData,
            };
            this.controlaEstoque(documento.id);
            db.collection("Carrinho")
              .add({
                DataAdicionado: Timestamp.now(),
                DataExpiracao: timeStamp,
                ItensCarrinho: {
                  [documento.id + " " + this.unidadeSelecionada]: produtoNovo,
                },
              })
              .then((docRef) => {
                this.idCarrinho(docRef.id);
                this.contadorProdutos(1);
                this.handleOpenMenu(event);
                loader.hide();
              });
          } else {
            this.$fire({
              text: "Você atingiu a quantidade liberada por cliente para esta promoção",
            });
            loader.hide();
          }
        }
      } else {
        this.$alert("Para prosseguir, escolha uma de nossas Unidades!");
        loader.hide();
      }
    },
    async excluirPromocao(id, unidade, quantidade) {
      await db
        .collection("Promocoes")
        .doc(id.replace(unidade, ""))
        .get()
        .then((doc) => {
          var mapa = doc.data().QtdUnidadesReserva;
          mapa[unidade] = doc.data().QtdUnidadesReserva[unidade] - quantidade;
          db.collection("Promocoes").doc(id.replace(unidade, "")).update({
            QtdUnidadesReserva: mapa,
          });
        });
      this.removerProduto(id);
    },
    criandoData(seconds) {
      var t = new Date(1970, 0, 1);
      t.setSeconds(seconds);
      this.dataOk = t;
    },
    habilitarUnidade(unidade) {
      this.contador = 1;
      this.unidadeSelecionada = unidade;
    },
    estoqueZero(unidade) {
      this.$alert("A promoção está esgotada para a " + unidade + "!");
    },
    getQuantidade() {
      db.collection("Promocoes")
        .doc(this.id)
        .onSnapshot((doc) => {
          this.qtdPromocao = doc.data().QtdUnidades;
          this.qtdPromocao["Unidade Vila Velha"] =
            parseInt(this.qtdPromocao["Unidade Vila Velha"]) -
            parseInt(doc.data().QtdUnidadesReserva["Unidade Vila Velha"]);
          this.qtdPromocao["Unidade Vitória"] =
            parseInt(this.qtdPromocao["Unidade Vitória"]) -
            parseInt(doc.data().QtdUnidadesReserva["Unidade Vitória"]);
          this.qtdMaxCliente = doc.data().QtdMaxCliente;
        });
    },
    adicionaUnidade(unidade) {
      if (
        this.contador < parseInt(this.qtdPromocao[unidade]) &&
        this.contador < this.qtdMaxCliente
      ) {
        this.contador++;
      } else {
        this.$alert(
          "Você atingiu a quantidade liberada por cliente para esta promoção"
        ).then();
      }
    },
  },
};
</script>

<style scoped>
.content {
  max-width: 1174px;
  margin: 40px auto 0 auto;
  padding: 40px;
  display: grid;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

@media (max-width: 960px) {
  .content {
    margin: 30px auto;
    grid-template-columns: 1fr;
    width: 95%;
    padding: 20px 20px;
    gap: 10px;
  }
}

.content img {
  max-width: 100%;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
}

.expira {
  display: flex;
  color: #ccc;
  align-items: center;
}

.expira-hora {
  margin: 0 0 0 8px;
}

.dados h2 {
  margin: 20px auto 0 auto;
  font-size: 1.8em;
  color: #333;
  font-weight: 800;
}

.data {
  color: #f85e28;
  font-weight: 600;
  font-size: 1.3em;
  margin: 8px auto;
}

.preco {
  color: #333;
  font-weight: 600;
  font-size: 1.3em;
  margin: 8px auto;
}

.subtitulo {
  color: #2e9189;
  font-size: 1.1em;
  font-weight: 500;
}

.botao button {
  border: 2px solid #f85e28;
  padding: 4px 8px;
  border-radius: 5px;
  cursor: pointer;
  color: #f85e28;
  font-size: 1.1em;
  margin: 8px;
  width: 140px;
}

.descricao {
  grid-column: span 2;
  font-size: 1.3em;
  color: #999;
}

.icones2 {
  grid-column: 1;
  display: flex;
  justify-content: center;
  justify-items: center;
  color: #2e9189;
}

.icones2-div {
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 180px;
}

.icone_svg2 {
  width: 30px;
  height: 30px;
}

.icones {
  grid-column: span 2;
  display: flex;
  justify-content: center;
  justify-items: center;
  color: #2e9189;
}

.icones-div {
  display: flex;
  align-items: center;
  margin: 0 auto;
}

.icone_svg {
  width: 36px;
  height: 36px;
}

.icone_ampulheta {
  width: 20px;
  height: 20px;
}

.icone-relogio {
  margin: 0 0 0 15px;
}

.icones-div span {
  width: 160px;
  text-align: center;
  margin: 0 10px;
}

.contador {
  font-size: 2.4em;
  margin: 12px 0 12px 0;
}

.finalizar {
  display: flex;
}

.finalizar button {
  margin: 0 auto;
}

.adicao-subtracao {
  cursor: pointer;
}

.adicionar {
  display: block;
  padding: 14px 50px;
  background: #f85e28;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  font-size: 1rem;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  margin-top: 20px;
}

.adicionar:hover {
  background: #e1331b;
  transform: scale(1.1);
}

.turno {
  padding: 5px 0 0 0;
}

.data-horario {
  display: none;
}

.espaco {
  display: block;
  padding: 9px 0 0 0;
}

@media (max-width: 960px) {
  .descricao,
  .icones {
    grid-column: 1;
  }
  .descricao {
    font-size: 1.1em;
  }
  .icones {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
  }
  .icones-div {
    margin: 15px auto;
  }
}

@media (max-width: 560px) {
  .icones {
    grid-template-columns: 1fr;
  }
  .icones2 {
    display: grid;
  }
  .icones2-div {
    font-size: 0.9em;
    font-weight: 500;
  }
  .dados h2 {
    margin: 0 auto;
    font-size: 1.5em;
    font-weight: 700;
  }
  .expira {
    font-size: 0.9rem;
    display: none;
  }
  .data {
    font-weight: 500;
    font-size: 1.1em;
  }
  .preco {
    font-weight: 500;
    font-size: 1.1em;
    margin: 8px auto;
    color: #f85e28;
  }
  .botao button {
    padding: 5px 8px;
    font-size: 1em;
    margin: 8px 6px 0 6px;
    width: 120px;
  }
  .contador {
    font-size: 2em;
    margin: 10px 0 -10px 0;
  }
  .adicionar {
    padding: 14px 20px;
  }
  .finalizar button {
    margin: 20px auto;
  }
  .data-horario {
    display: block;
    margin: 5px 0;
    color: #f85e28;
    text-align: center;
    font-weight: 500;
    font-size: 0.95em;
    letter-spacing: -0.5px;
  }
  .data-horario span {
    padding: 0 0 0 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Comprar.vue